import Text from 'components/shared/Text'
import styled, { css } from 'styled-components/macro'

interface SelfcareTextProps {
    isCompleted?: boolean
}

export const SelfcareText = styled(Text)<SelfcareTextProps>`
    ${({ isCompleted }) =>
        isCompleted &&
        css`
            text-decoration: line-through;
            color: ${({ theme }) => theme.colors.grayscale_700};
        `}
`
